const estadoInicial = () => ({
  token: null,
  identificadorPublico: null,
  autenticado: false,
})

export const pep = {
  namespaced: true,

  state: estadoInicial,

  getters: {
    token: (state) => state.token,

    identificadorPublico: (state) => state.identificadorPublico,

    autenticado: (state) => {
      return Boolean(
        state.autenticado && state.token && state.identificadorPublico
      )
    },
  },

  mutations: {
    setAutenticacao(state, payload) {
      state.token = payload.token
      state.identificadorPublico = payload.identificadorPublico
      state.autenticado = true
    },

    limparAutenticacao(state) {
      Object.assign(state, estadoInicial())
    },
  },

  actions: {
    salvarAutenticacao({ commit }, payload) {
      commit('setAutenticacao', payload)
    },

    logout({ commit }) {
      commit('limparAutenticacao')
    },
  },
}
